// Paths for quick start flow

export const quickstartSelectSourcePath = args => {
  return `/${args.workspaceSlug}/quickstart`
}

export const quickstartSelectedSourcePath = args => {
  return `/${args.workspaceSlug}/quickstart/${args.sourceSlug}`
}

export const quickstartSelectDestinationPath = args => {
  return `/${args.workspaceSlug}/quickstart/${args.sourceSlug}/destinations`
}

export const quickstartSelectedDestinationPath = args => {
  return `/${args.workspaceSlug}/quickstart/${args.sourceSlug}/destinations/${
    args.destinationSlug
  }`
}

export const quickstartDestinationConfigPath = args => {
  return `/${args.workspaceSlug}/quickstart/${args.sourceSlug}/destinations/${
    args.destinationSlug
  }/config`
}

export const quickstartSourceInstallPath = args => {
  return `/${args.workspaceSlug}/quickstart/${args.sourceSlug}/destinations/${
    args.destinationSlug
  }/install`
}

export const quickStartAutoDetect = args => {
  return `/${args.workspaceSlug}/quickstart/${
    args.sourceSlug
  }/destinations/auto-detect`
}

export const quickStartJavascriptSelectionPath = args => {
  return `/${
    args.workspaceSlug
  }/quickstart/javascript/destinations/javascript-selection`
}
